import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

/*
  SmartAdmin input group - default input element for forms
  <InputGroup
    disabled - boolean attribute that makes the input field un-clickable until a condition is met
    type="text/number,password,etc" - value type of the input field
    label="text" - header to associate with input field (optional)
    placeholder="text" - describe the expected value of the input field
    value="text" - defines the text (button/reset/submit)
                 - defines the initial value (text/password)
                 - defines the value and sends it on submit (checkbox/radio)
  />

  Other props included in <InputField> such as onChange and onClick functions will work as usual
*/

const InputGroup = props => {
  const {
    id,
    label,
    placeholder,
    value,
    type,
    ...rest
  } = props;

  return (
    <div className="form-group">
      {!isEmpty(label) ? <label className="form-label" htmlFor="input-group">{label}</label> : null}
      <input
        id={id}
        className="form-control text-input"
        type={type}
        placeholder={placeholder}
        value={value}
        {...rest}
      />
    </div>
  );
};

InputGroup.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.node,
  type: PropTypes.string.isRequired,
};

InputGroup.defaultProps = {
  id: '',
  label: null,
};

export default InputGroup;
